export enum PlatformType {
  DESKTOP = "desktop",
  MOBILE = "mobile"
}
